import styled from 'styled-components'

import theme from 'theme'

export const Container = styled.div``

export const MenuItemContainer = styled.div`
  margin-top: ${theme.spacing.xs};
`
